import { Product } from '@/queries/types/graphql';

const getProductFinish = (product: Product): string | undefined => {
  return product?.selectedTraits?.find((trait) => trait?.name === 'Color')
    ?.value;
};

export default getProductFinish;
